<template>
  <div style="padding: 10px">
    <el-button style="margin-bottom: 10px" type="primary" icon="el-icon-plus"
      @click="openEditVersionDialog(true)">新增版本项</el-button>
    <el-tooltip style="margin-left: 15px;" effect="dark" placement="top">
      <div slot="content">1、“环境”，指的是对应版本的游戏将会访问哪个服务器<br />2、凡是没有在这里被列出的版本，“环境”都默认是“正式”</div>
      <span style="font-size: 1.5rem;"><i class="el-icon-question"></i></span>
    </el-tooltip>

    <el-table :data="versionList" border size="small" style="width: 760px">
      <el-table-column prop="channelName" label="渠道" align="center" width="150">
      </el-table-column>
      <el-table-column prop="minVersion" label="最低版本" align="center" width="80">
      </el-table-column>
      <el-table-column prop="maxVersion" label="最高版本" align="center" width="80">
      </el-table-column>
      <el-table-column label="环境" align="center" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.env == 0" class="env-tag env-tag-dev">开发</span>
          <span v-if="scope.row.env == 1" class="env-tag env-tag-test">测试</span>
          <span v-else-if="scope.row.env == 2" class="env-tag env-tag-stage">审核</span>
          <span v-else-if="scope.row.env == 3" class="env-tag env-tag-prod">正式</span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" align="center" width="200"></el-table-column>
      <el-table-column label="操作" align="center" width="150">
        <template slot-scope="scope">
          <el-button type="danger" round size="mini" @click="deleteVersion(scope.row.id, scope.row)">删除</el-button>
          <el-button type="primary" round size="mini" @click="openEditVersionDialog(false, scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 编辑对话框 -->
    <EditVersionDialog v-if="shouldEditVersionDialogVisible" @close="onEditVersionDialogClosed()"
      :value="valueForEditVersionDialog"></EditVersionDialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import EditVersionDialog from "./EditVersionDialog";

export default {
  data() {
    return {
      availableChannels: [], // 所有可用的渠道
      shouldEditVersionDialogVisible: false, // 编辑对话框是否应该显示出来
      valueForEditVersionDialog: null, // 要传递给编辑对话框的数据
      versionList: [], // 列表里展示的数据
    };
  },

  async created() {
    // 拉取渠道集合
    await this.loadAvailableChannels();

    // 拉取集合
    this.loadVersionList();
  },

  components: {
    EditVersionDialog,
  },

  methods: {
    /**
     * 拉取渠道集合
     */
    async loadAvailableChannels() {
      this.availableChannels = await bizutil.loadAvailableChannels();
    },

    /**
     * 查询集合
     */
    async loadVersionList() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/version/getList`,
          {},
          {
            headers: {
              token: util.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.versions || [];

      // 排序（按id倒序排列）
      listInResponse.sort((x, y) => {
        return y.id - x.id;
      });

      this.versionList = listInResponse;

      // 补上渠道名称
      for (let v of this.versionList) {
        for (let c of this.availableChannels) {
          if (c.id == v.channelId) {
            v.channelName = c.name;
            break;
          }
        }
      }
    },

    /**
     * 删除
     * @param {*} id
     * @param {*} entry
     */
    async deleteVersion(id, entry) {
      try {
        // 弹确认框
        await this.$confirm(`确认删除该版本项？`);

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/version/delete`,
            {
              id: id,
            },
            {
              headers: {
                token: util.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "删除成功",
          type: "success",
        });

        for (let i = 0; i < this.versionList.length; i++) {
          if (this.versionList[i].id == id) {
            this.versionList.splice(i, 1);
          }
        }
      } catch (e) { }
    },

    /**
     * 打开编辑对话框
     */
    async openEditVersionDialog(isCreate, oldData) {
      this.shouldEditVersionDialogVisible = true;
      this.valueForEditVersionDialog = {
        isCreate: isCreate,
        oldData: oldData,
      };
    },

    /**
     * 编辑对话框关闭了
     */
    async onEditVersionDialogClosed() {
      this.shouldEditVersionDialogVisible = false;

      // 重新拉取集合
      return this.loadVersionList();
    },
  },
};
</script>

<style lang="scss" scoped>
.env-tag {
  display: inline-block;
  padding: 0 10px;
  border: 1px solid #d9ecff;
  border-radius: 2px;
}

.env-tag-test {
  border: 2px solid lightgray;
}

.env-tag-stage {
  border: 2px solid red;
}

.env-tag-prod {
  border: 2px solid chartreuse 
}
</style>